import React from "react";
import { mergeStyleSets } from "office-ui-fabric-react";
import TimePicker from "react-time-picker";
import { MyContext } from "../../context";

const classNames = mergeStyleSets({
  flexContainerStart: {
    display: "flex",
    alignItems: "flex-start",
  },
  ml10: {
    marginLeft: "10px",
  },
  mr10: {
    marginRight: "10px",
  },
});

const StartEndTimePicker = ({ style, startTime, endTime, updateState, updateNestedState, nested, startKey, endKey, day }) => {
  return (
    <MyContext.Consumer>
      {(context) => (
        <div style={style} className={classNames.flexContainerStart}>
          <p className={classNames.mr10}>{context.getTranslation("recordingRule", "startTime")}</p>
          <TimePicker
            className={classNames.mr10}
            value={startTime}
            format="HH:mm:ss"
            maxDetail="second"
            disableClock={true}
            clearIcon={null}
            hourPlaceholder="hh"
            minutePlaceholder="mm"
            secondPlaceholder="ss"
            onChange={(newValue) => {
              !nested ? updateState(startKey, newValue) : updateNestedState("week", day, { [startKey]: newValue });
            }}
          />
          <p className={classNames.mr10}>{context.getTranslation("recordingRule", "endTime")}</p>
          <TimePicker
            value={endTime}
            format="HH:mm:ss"
            maxDetail="second"
            disableClock={true}
            clearIcon={null}
            hourPlaceholder="hh"
            minutePlaceholder="mm"
            secondPlaceholder="ss"
            onChange={(newValue) => {
              !nested ? updateState(endKey, newValue) : updateNestedState("week", day, { [endKey]: newValue });
            }}
          />
        </div>
      )}
    </MyContext.Consumer>
  );
};

export default StartEndTimePicker;
